import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["link", "list"];
  }

  connect() {
    location.hash && this.findByHash(location.hash, this.linkTargets) ? this.view(location.hash) : this.viewFirst();
  }

  view(eventOrHash) {
    let hash = typeof eventOrHash === "object" ? event.target.dataset.hash : eventOrHash;

    if (this.currentLink) this.currentLink.classList.remove("header-active");
    if (this.currentList) this.currentList.classList.add("hidden");

    this.currentLink = this.findByHash(hash, this.linkTargets);
    this.currentList = this.findByHash(hash, this.listTargets);

    this.currentLink.classList.add("header-active");
    this.currentList.classList.remove("hidden");
  }

  viewFirst() {
    this.view(this.linkTargets[0].dataset.hash);
  }

  findByHash(hash, targets) {
    return targets.find((elm) => elm.dataset.hash === hash);
  }
}
